import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/system';
// material
import { styled } from '@mui/material/styles';

import Header from '../layouts/staff/dashboard/header/Header';
import Navbar from '../layouts/staff/dashboard/navbar/Navbar';
import { useMutation, useQuery } from 'react-fetching-library';
import { getStaffApplicationsAction, markNewDocumentsAsRead, uploadCheckboxSectionFileAction } from '../services/request';
import { CircularProgress } from '@mui/material';
import toast from 'react-hot-toast';
import { NewDocumentAddedDialog } from './staff/NewDocumentAddedDialog';


// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  overflow: 'hidden',
  margin: '0 5px'
});

const HeaderStyle = styled('div')(({ theme }) => ({
  padding: '20px 0px',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------
const StaffContext = React.createContext([null, _ => {}]);

export default () => {
  const { loading, payload, error } = useQuery(getStaffApplicationsAction('GET'));
  const { loading: optionsLoading, payload: optionsPayload, error: optionsError } = useQuery(getStaffApplicationsAction('OPTIONS'));
  const { mutate } = useMutation(markNewDocumentsAsRead);
  const uploadFileMutation = useMutation(uploadCheckboxSectionFileAction);
  const [applications, setApplications] = React.useState([]);
  const [application, setApplication] = React.useState(null);
  const [showNewDocumentAddedDialog, setShowNewDocumentAddedDialog] = React.useState(false);
  const [choices, setChoices] = React.useState({});

  const updateApplication = async () => {
    const { payload, error, loading: qLoading } = await mutate(application.id);
    if (!error && !qLoading) {
      setApplication(prev => ({ ...prev, new_document_added_by_office: false }));
    }
  };

  const uploadCheckboxSectionFile = async (checkboxSectionId, formData) => {
    formData.append('new_document_added_by_staff', true);
    const { error, payload } = await uploadFileMutation.mutate(formData, checkboxSectionId);

    if (!error) {
      setApplication(prev => ({ ...prev, checkbox_sections: [...prev.checkbox_sections.map(cs => cs.id == payload.id ? payload : cs)] }));

      return true;
    }

    return false;
  };

  React.useEffect(() => {
    if (!error && !loading) {
      if (payload.length > 0) {
        setApplications(payload);
        setApplication(payload[0]);
        if (payload[0].new_document_added_by_office) {
          setShowNewDocumentAddedDialog(true);
        }
      }
    }
    if (error) {
      toast.error('Wystąpił błąd');
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsError && !optionsLoading) {
      setChoices(optionsPayload.actions.GET.choices);
    }
  }, [optionsLoading]);

  return (
    <StaffContext.Provider value={{ applications,
      setApplications,
      application,
      setApplication,
      choices,
      setChoices,
      uploadCheckboxSectionFile }}>
      {loading
        ? <Box height={300}>
          <CircularProgress />
        </Box>
        : <RootStyle>
          <HeaderStyle>
            <Header />
          </HeaderStyle>
          <MainStyle>
            <Navbar />
            <Box height={20} />
            {showNewDocumentAddedDialog && <NewDocumentAddedDialog
              open={showNewDocumentAddedDialog}
              setOpen={setShowNewDocumentAddedDialog}
              updateApplication={updateApplication} />}
            <Outlet />
          </MainStyle>
        </RootStyle>
      }
    </StaffContext.Provider>
  );
};

export const useStaff = () => React.useContext(StaffContext);
